"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCALES = void 0;
var _dmsbasereact = require("dmsbasereact");
const LOCALES = exports.LOCALES = {
  [_dmsbasereact.LanguageEnum.EN_US]: require("../locales/en_US.json"),
  [_dmsbasereact.LanguageEnum.PT_BR]: require("../locales/pt_BR.json"),
  [_dmsbasereact.LanguageEnum.ES_MX]: require("../locales/es_MX.json")
};